import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reseaux-sociaux',
  templateUrl: './reseaux-sociaux.component.html',
  styleUrls: ['./reseaux-sociaux.component.scss']
 
})
export class ReseauxSociauxComponent implements OnInit {

  currentYear = new Date().getFullYear();

  
  // Hero Section
  pageTitle = "Gestion des Réseaux Sociaux en France";
  pageSubtitle = "Développez votre communauté et engagez votre audience sur tous les réseaux sociaux";
  
  // Stats
  stats = [
    { number: '+280%', label: 'Engagement Moyen' },
    { number: '15min', label: 'Temps de Réponse' },
    { number: '97%', label: 'Satisfaction Client' },
    { number: '300+', label: 'Comptes Gérés' }
  ];
  
  // Platforms
  platforms = [
    {
      icon: '📘',
      name: 'Facebook',
      description: 'Créez une communauté engagée et générez des leads qualifiés',
      color: '#1877F2'
    },
    {
      icon: '📸',
      name: 'Instagram',
      description: 'Boostez votre notoriété avec du contenu visuel captivant',
      color: '#E1306C'
    },
    {
      icon: '💼',
      name: 'LinkedIn',
      description: 'Développez votre réseau B2B et positionnez-vous en expert',
      color: '#0077B5'
    },
    {
      icon: '🎬',
      name: 'TikTok',
      description: 'Touchez une audience jeune avec des vidéos virales',
      color: '#000000'
    },
    {
      icon: '🐦',
      name: 'Twitter/X',
      description: 'Partagez votre expertise et suivez les tendances',
      color: '#1DA1F2'
    },
    {
      icon: '📌',
      name: 'Pinterest',
      description: 'Inspirez et attirez du trafic qualifié vers votre site',
      color: '#E60023'
    }
  ];
  
  // Services
  services = [
    {
      icon: '📝',
      title: 'Création de Contenu',
      description: 'Nous créons du contenu engageant adapté à chaque plateforme',
      features: [
        'Rédaction de posts créatifs',
        'Design de visuels professionnels',
        'Vidéos courtes et reels',
        'Stories captivantes'
      ]
    },
    {
      icon: '📅',
      title: 'Planning & Publication',
      description: 'Programmation stratégique de vos publications pour une visibilité maximale',
      features: [
        'Calendrier éditorial personnalisé',
        'Publication aux meilleurs moments',
        'Gestion multi-plateformes',
        'Hashtags optimisés'
      ]
    },
    {
      icon: '💬',
      title: 'Community Management',
      description: 'Animez votre communauté et créez des liens durables avec votre audience',
      features: [
        'Réponses aux commentaires',
        'Modération professionnelle',
        'Gestion des messages privés',
        'Animation de discussions'
      ]
    },
    {
      icon: '📊',
      title: 'Analyse & Reporting',
      description: 'Suivez vos performances et optimisez votre stratégie en continu',
      features: [
        'Rapports mensuels détaillés',
        'Analyse de l\'engagement',
        'Étude de la concurrence',
        'Recommandations stratégiques'
      ]
    }
  ];
  
  // Pricing Packages
  packages = [
    {
      name: 'Essentiel',
      price: '490',
      period: '€/mois',
      description: 'Pour démarrer votre présence sociale',
      platforms: '2 réseaux sociaux',
      posts: '12 publications/mois',
      features: [
        'Création de contenu (texte + visuels)',
        'Programmation des posts',
        'Réponses aux commentaires',
        'Rapport mensuel basique'
      ],
      popular: false
    },
    {
      name: 'Croissance',
      price: '890',
      period: '€/mois',
      description: 'Pour développer votre communauté',
      platforms: '4 réseaux sociaux',
      posts: '24 publications/mois',
      features: [
        'Création de contenu avancé',
        'Stories + Reels (8/mois)',
        'Community management complet',
        'Gestion messages privés',
        'Rapport détaillé mensuel',
        'Veille concurrentielle'
      ],
      popular: true
    },
    {
      name: 'Premium',
      price: '1590',
      period: '€/mois',
      description: 'Solution complète pour entreprises ambitieuses',
      platforms: 'Tous les réseaux',
      posts: '40 publications/mois',
      features: [
        'Tout du forfait Croissance',
        'Vidéos professionnelles (4/mois)',
        'Campagnes publicitaires incluses',
        'Social media manager dédié',
        'Rapports hebdomadaires',
        'Stratégie d\'influence',
        'Formation mensuelle'
      ],
      popular: false
    }
  ];
  
  // FAQ
  faqs = [
    {
      id: 1,
      question: 'Sur quels réseaux sociaux devez-vous être présent ?',
      answer: 'Cela dépend de votre secteur et de votre audience cible. En B2C, Instagram et Facebook sont essentiels. En B2B, LinkedIn est prioritaire. Nous vous conseillons les plateformes les plus pertinentes lors de notre audit.',
      active: false
    },
    {
      id: 2,
      question: 'À quelle fréquence devez-vous publier ?',
      answer: 'La fréquence optimale varie selon les plateformes : 1 post/jour sur Instagram, 3-5/semaine sur LinkedIn, 1-2/jour sur Twitter. Nos forfaits incluent un planning adapté à chaque réseau.',
      active: false
    },
    {
      id: 3,
      question: 'Fournissez-vous les images et visuels ?',
      answer: 'Oui, nous créons tous les visuels professionnels. Si vous avez des photos de vos produits/services, nous les utiliserons. Sinon, nous utilisons des banques d\'images premium ou créons des designs sur mesure.',
      active: false
    },
    {
      id: 4,
      question: 'Combien de temps avant de voir des résultats ?',
      answer: 'Les premières interactions apparaissent dès la première semaine. Une croissance significative de la communauté se voit généralement après 3 mois de travail régulier et de qualité.',
      active: false
    },
    {
      id: 5,
      question: 'Puis-je valider les publications avant ?',
      answer: 'Absolument ! Vous validez le calendrier éditorial et les contenus avant publication. Nous travaillons en collaboration totale avec vous.',
      active: false
    }
  ];
  
  // Testimonials
  testimonials = [
   
    {
      text: "Résultats impressionnants en un temps record.",
      name: "Mohamed Alami",
      company: "Start-up Innovante",
      image: "assets/images/m2.jpeg"
    },
    {
      text: "Je recommande vivement leurs services.",
      name: "Fatima Zahra",
      company: "E-commerce Pro",
      image: "assets/images/w2.webp"
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }
  
  toggleFaq(faqId: number): void {
    this.faqs.forEach(faq => {
      if (faq.id === faqId) {
        faq.active = !faq.active;
      } else {
        faq.active = false;
      }
    });
  }
  
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}